// frontend/src/components/builder/PropertiesPanel.tsx
import React from 'react';
import { CanvasItem } from '@/pages/BuilderPage';
import SchemaDrivenForm from './SchemaDrivenForm';

interface PropertiesPanelProps {
  item: CanvasItem | null;
  onUpdateProps: (id: string, newProps: any) => void;
}

export default function PropertiesPanel({ item, onUpdateProps }: PropertiesPanelProps) {
  if (!item) {
    return (
      <div className="w-full h-full p-4 flex flex-col items-center justify-center bg-gray-50">
        <div className="font-bold text-lg text-gray-400 mb-2">Properties Window</div>
        <div className="text-gray-500">
          Select a component on the phone canvas to see and edit its properties.
        </div>
      </div>
    );
  }

  const hasSchema = item.metadata.validation && item.metadata.validation.schema;

  return (
    <div className="w-full h-full flex flex-col">
      <div className="bg-gray-100 border-b px-4 py-2 flex items-center justify-between">
        <span className="font-bold text-gray-700">{item.metadata.name} Properties</span>
        <span className="text-xs text-gray-400 bg-white px-2 py-1 rounded border">ID: {item.metadata.id}</span>
      </div>
      
      <div className="flex-1 overflow-y-auto p-4 flex justify-center">
        <div className="w-full max-w-4xl">
          {hasSchema ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <SchemaDrivenForm
                schema={item.metadata.validation.schema}
                defaultValues={item.props}
                onUpdate={(newProps) => onUpdateProps(item.instanceId, newProps)}
              />
            </div>
          ) : (
            <div className="flex items-center justify-center h-full text-gray-500 italic">
              This component has no configurable properties.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
